import type { ImageResolution } from "../types";

export type ImageModelSettings = {
	aspectRatios: readonly string[];
	resolutions: readonly ImageResolution[];
	outputOptions: readonly number[];
	/** 参考图上限，只在比站内默认的 5 张小时填（qwen3 上游只收 3 张） */
	maxInputImages?: number;
};

/** 不填 maxInputImages 时的参考图上限，跟工作台 / hero 原来写死的一致 */
export const DEFAULT_MAX_INPUT_IMAGES = 5;

/** 当前界面开放的模型参数；模板仍可限制其中的分辨率选项。 */
export const IMAGE_MODEL_SETTINGS = {
	"v3.0": {
		aspectRatios: ["1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K", "4K"],
		outputOptions: [1, 2, 3, 4],
	},
	"gpt-image-2": {
		aspectRatios: ["auto", "1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K", "4K"],
		outputOptions: [1, 2, 3, 4],
	},
	"nano-banana-2": {
		aspectRatios: ["auto", "1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K", "4K"],
		outputOptions: [1, 2, 3, 4],
	},
	"nano-banana-pro": {
		aspectRatios: ["auto", "1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K", "4K"],
		outputOptions: [1, 2, 3, 4],
	},
	"nano-banana-2-1": {
		aspectRatios: ["auto", "1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K", "4K"],
		outputOptions: [1, 2, 3, 4],
	},
	// qwen3 / seedream 5 pro / flash 上游都没有 auto，最高 2K
	"qwen-image-3": {
		aspectRatios: ["1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K"],
		outputOptions: [1, 2, 3, 4],
		maxInputImages: 3,
	},
	"qwen-image-3-pro": {
		aspectRatios: ["1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K"],
		outputOptions: [1, 2, 3, 4],
		maxInputImages: 3,
	},
	"seedream-5-pro": {
		aspectRatios: ["1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K"],
		outputOptions: [1, 2, 3, 4],
	},
	"seedream-5-flash": {
		aspectRatios: ["1:1", "16:9", "9:16", "3:4", "4:3", "3:2", "2:3"],
		resolutions: ["1K", "2K"],
		outputOptions: [1, 2, 3, 4],
	},
} satisfies Record<string, ImageModelSettings>;

export function getImageModelSettings(model?: string | null): ImageModelSettings {
	return IMAGE_MODEL_SETTINGS[model as keyof typeof IMAGE_MODEL_SETTINGS] ?? IMAGE_MODEL_SETTINGS["v3.0"];
}

export function getMaxInputImages(model?: string | null): number {
	return getImageModelSettings(model).maxInputImages ?? DEFAULT_MAX_INPUT_IMAGES;
}
